import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_right",
  "use": "chevron_right-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"chevron_right\">\r\n<title>chevron_right</title>\r\n<path d=\"M9.672 32l-3.343-3.343 12.657-12.657-12.657-12.657 3.343-3.343 16 16z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol